// const input = document.querySelector('input[type="file"]')
// input.addEventListener('change', async e => {
//     const file = e.target.files[0]
//     if (file.size > 1024 * 1024) {
//         const compressedBlob = await compressImageToSize(file, 1024 * 1024)
//         // 你可以用 compressedBlob 生成新的 File 或上传
//         const compressedFile = new File([compressedBlob], file.name, { type: 'image/jpeg' })
//         console.log('压缩后大小:', compressedFile.size)
//     } else {
//         console.log('无需压缩')
//     }
// })
import { getSysControlParamList } from '../api/toDo/sysParamsConfig.js'
export async function checkSwitchAndCompress(file){
    return new Promise(async (resolve, reject) => {
        try{
            const switchRes = await getSysControlParamList({ controlCode: 'fileCompressSwitch' })
            const compressSwitch = switchRes && +switchRes.code === 0 && switchRes.data.list && switchRes.data.list[0] && switchRes.data.list[0].controlValue === 'true'
            if(compressSwitch){
                //压缩开关打开
                const sizeRes = await getSysControlParamList({ controlCode: 'fileCompressSize' })
                const limitSize = (sizeRes && +sizeRes.code === 0 && sizeRes.data.list && sizeRes.data.list[0] && sizeRes.data.list[0].controlValue ? sizeRes.data.list[0].controlValue : 1) * 1024 * 1024
                if(file.size > limitSize){
                    //文件大小比配置大
                    const compressedBlob = await compressImageToSize(file, limitSize)
                    const compressedFile = new File([compressedBlob], file.name, { type: 'image/jpeg' })
                    console.log('压缩前大小:', file.size / 1024 / 1024,'压缩后大小:', compressedFile.size / 1024 / 1024, '压缩比例：', compressedFile.size / file.size)
                    resolve(compressedFile)
                }else{
                    console.log('文件大小比配置小，无需压缩')
                    resolve(file)
                }
            }else{
                console.log('压缩开关关闭，无需压缩')
                //不需要压缩
                resolve(file)
            }
        }catch(e){
            console.log('压缩错误：',e)
            resolve(file)
        }
    })
    
}
/**
 * 压缩图片到指定大小（以字节为单位）
 * @param {File} file - 原始图片文件
 * @param {number} maxSize - 最大字节数（如 1MB = 1024 * 1024）
 * @returns {Promise<Blob>} - 压缩后的图片 Blob
 */
export async function compressImageToSize(file, maxSize = 1024 * 1024) {
    return new Promise((resolve, reject) => {
        const img = new Image()
            const reader = new FileReader()
    
            reader.onload = function (e) {
                img.src = e.target.result
            }
    
            img.onload = function () {
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                let [w, h] = [img.width, img.height]
                canvas.width = w
                canvas.height = h
                ctx.drawImage(img, 0, 0, w, h)
    
                let quality = 0.3 // 初始压缩质量
                function compress() {
                    canvas.toBlob(
                        blob => {
                            if (blob.size <= maxSize || quality < 0.1) {
                                resolve(blob)
                            } else {
                                quality -= 0.05
                                compress()
                            }
                        },
                        'image/jpeg',
                        quality,
                    )
                }
                compress()
            }
    
            reader.onerror = reject
            img.onerror = reject
    
            reader.readAsDataURL(file)
    })
}
